import React from 'react';
import { Form, Input, Col, Row } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';

const ValidationErrors = {
  required: (field: string) => `${field} is required.`,
};

const ChangePasswordForm: React.FC = React.memo(() => {
  const validateConfirmPassword = ({ getFieldValue }: { getFieldValue: (name: string) => string }) => ({
    validator(_: unknown, value: string) {
      if (!value || getFieldValue('password') === value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('Passwords do not match.'));
    },
  });

  return (
    <Row style={{ marginTop: 20 }} gutter={[8, 16]}>
      <Col span={24}>
        <Form.Item
          name="currentPassword"
          label="Current Password*"
          rules={[{ required: true, message: ValidationErrors.required('Current Password') }]}
        >
          <Input.Password
            iconRender={(visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
            size="large"
          />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item
          name="password"
          label="New Password*"
          help="Password must be at least 12 characters."
          rules={[
            { required: true, message: ValidationErrors.required('New Password') },
            {
              validator: (_: unknown, value?: string) =>
                (value?.trim() || '')?.length >= 12
                  ? Promise.resolve()
                  : Promise.reject(new Error('Password must be at least 12 characters long.')),
            },
          ]}
        >
          <Input.Password
            iconRender={(visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
            size="large"
          />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item
          name="passwordRepeat"
          label="Confirm Password*"
          dependencies={['password']}
          rules={[
            { required: true, message: ValidationErrors.required('Confirm New Password') },
            validateConfirmPassword,
          ]}
        >
          <Input.Password
            iconRender={(visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
            size="large"
          />
        </Form.Item>
      </Col>
    </Row>
  );
});

export default ChangePasswordForm;
